// extracted by mini-css-extract-plugin
export default {"progressBarContainer":"SwiperProgress_progressBarContainer__dEVQN","progressBar":"SwiperProgress_progressBar__1kkex","progressDot":"SwiperProgress_progressDot__8fgxx"};